import { createContext } from "react";

const ParentDimensionsContext = createContext<{ width: number; height: number } | undefined>(undefined);
ParentDimensionsContext.displayName = "ParentDimensionsContext";
export default ParentDimensionsContext;
